/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "parcel-truck-02f8dd22--sprite",
  "use": "parcel-truck-02f8dd22--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"parcel-truck-02f8dd22--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(9165 18078)\" opacity=\"0\"><g transform=\"translate(-9165 -18078)\"><path d=\"M18.1,323.111A17.992,17.992,0,1,1,.108,341.1h0A17.992,17.992,0,0,1,18.1,323.111Z\" transform=\"translate(-0.108 -323.111)\" fill=\"#fcf8d0\" /></g></g><g transform=\"translate(306.18 -448.254)\"><path d=\"M-278.27,465.8l-2.1-5.3h-19.174a.73.73,0,0,0-.72.745s0,8.862,0,8.9a.736.736,0,0,0,.715.637h4.061a2.119,2.119,0,0,1,.348-1.166,2.184,2.184,0,0,1,.583-.6,2.127,2.127,0,0,1,1.205-.372,2.128,2.128,0,0,1,1.788.97,2.119,2.119,0,0,1,.348,1.166h9.411a2.084,2.084,0,0,1,.211-.921,2.039,2.039,0,0,1,.5-.666,2.109,2.109,0,0,1,1.426-.549,2.138,2.138,0,0,1,2.136,2.136h1.475v-4.649Zm-3.057,0h-3.41v-3.561h3.41Zm.583,0v-3.561h.289l1.435,3.561Z\" fill=\"currentColor\" /><path d=\"M-286.2,480.023a1.4,1.4,0,0,1-1.4,1.4,1.4,1.4,0,0,1-1.4-1.4,1.393,1.393,0,0,1,.193-.708,1.443,1.443,0,0,1,.434-.461,1.4,1.4,0,0,1,.772-.23,1.4,1.4,0,0,1,.772.23A1.4,1.4,0,0,1-286.2,480.023Z\" transform=\"translate(-5.749 -9.245)\" fill=\"currentColor\" /><g transform=\"translate(-281.066 469.379)\"><path d=\"M-258.274,480.023a1.4,1.4,0,0,1-1.4,1.4,1.4,1.4,0,0,1-1.4-1.4,1.4,1.4,0,0,1,1.4-1.4A1.4,1.4,0,0,1-258.274,480.023Z\" transform=\"translate(261.072 -478.624)\" fill=\"currentColor\" /></g><path d=\"M-259.578,463.967\" transform=\"translate(-20.756 -1.769)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
